<template>
  <div v-if="recommend">
    <div v-if="currentTeacher" class="teacher-view">
      <div class="body">
        <img class="avatar" :src="currentTeacher.photo" />
        <div class="right">
          <div class="name-wrap">
            <span class="name">{{currentTeacher.teacher_name}}</span>
            <span class="level" v-if="currentTeacher.level_name">{{currentTeacher.level_name}}</span>
          </div>
          <div class="marketing_language">{{currentTeacher.marketing_language}}</div>
          <div class="introduction">{{currentTeacher.introduction}}</div>
        </div>
        <div
          class="tag"
          v-if="currentTeacher.level_name&&$store.state.commonSetting.switch_oto_module==1&&false"
        >约课</div>
      </div>
      <div class="back"></div>
    </div>
    <div class="items clearfix">
      <TeacherItem
        v-for="(item,index) in recommend.list"
        :key="index"
        :class="{'teacher-current':currentTeacherIndex==index}"
        :data="item"
        @mouseover.native="currentTeacherIndex=index"
      ></TeacherItem>
    </div>
  </div>
</template>
<script>
import TeacherItem from "./TeacherItem.vue";
export default {
  name: "RecommendTeacher",
  components: { TeacherItem },
  props: {
    recommend: {
      type: Object
    }
  },
  data() {
    return {
      currentTeacherIndex: 0
    };
  },
  computed: {
    currentTeacher() {
      return this.recommend.list[this.currentTeacherIndex];
    }
  }
};
</script>
<style lang="scss" scoped>
.teacher-view {
  width: 1410px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 34px;
  margin-bottom: 32px;
  .body {
    display: flex;
    align-items: flex-end;
    width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;

    .avatar {
      width: 238px;
      height: 375px;
      border-radius: 5px;
      margin-right: 35px;
      flex-shrink: 0;
    }

    .name-wrap {
      margin-bottom: 26px;
      display: flex;
      align-items: center;
    }

    .name {
      font-size: 34px;
      color: #313437;
      line-height: 1;
    }

    .level {
      height: 30px;
      padding: 0 11px;
      background: rgba(237, 240, 247, 0);
      border: 1px solid #d5a94b;
      border-radius: 5px;
      font-size: 16px;
      color: #d5a94b;
      text-align: center;
      line-height: 28px;
      margin-left: 19px;
      box-sizing: border-box;
    }

    .marketing_language {
      height: 21px;
      font-size: 20px;
      color: rgba(102, 102, 102, 1);
      line-height: 21px;
      margin-bottom: 72px;
    }

    .introduction {
      height: 120px;
      font-size: 16px;
      color: rgba(112, 112, 112, 1);
      line-height: 30px;
      overflow: hidden;
    }
  }
  .back {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 200px;
    background: rgba(240, 240, 240, 1);
    opacity: 0.61;
    z-index: 0;
  }
  .tag {
    position: absolute;
    width: 48px;
    height: 22px;
    background-image: url("~@/assets/images/oto/tea-tag@2x.png");
    background-size: 100% 100%;
    font-size: 14px;
    color: white;
    line-height: 22px;
    box-sizing: border-box;
    padding-left: 15px;
    top: 0;
    left: 252px;
  }
}

.teacher-current {
  /deep/ {
    .arrow {
      display: block;
    }
  }
}

.items {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 48px;
}
</style>